import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer"]

  connect() {
    setTimeout(() => {
      this.show()
    }, 100)
  }

  show() {
    if (this.hasDrawerTarget) {
      this.drawerTarget.classList.remove("translate-x-full")
    }
  }

  hide() {
    if (this.hasDrawerTarget) {
      this.drawerTarget.classList.add("translate-x-full")
    }
  }

  toggle() {
    if (this.hasDrawerTarget) {
      this.drawerTarget.classList.toggle("translate-x-full")
    }
  }
}